export enum TradingIntentionType {
  OPERATING_BUSINESS = "operating-business",
  FAMILY_INVESTMENT_VEHICLE = "family-investment-vehicle",
  PROPRIETARY_TRADING = "proprietary-trading",
  FINANCIAL_INSTITUTION = "financial-institution"
}
